import { ReactNode } from "react";
import { FocusScope } from "@react-aria/focus";
import { OverlayContainer } from "@react-aria/overlays";
import "./Loading.scss";

const Loading = ({ children }: { children?: ReactNode }) => {
  return (
    <div className="loading">
      <div className="loading-spinner">
        <span />
        <span />
        <span />
        <span />
      </div>
      <p>{children}</p>
    </div>
  );
};

export const LoadingMask = ({
  children,
  fixed = false,
}: {
  children?: ReactNode;
  fixed?: boolean;
}) => {
  return (
    <div className={`loading-mask ${fixed ? " fixed" : ""}`}>
      <Loading>{children}</Loading>
    </div>
  );
};

export const LoadingOverlay = ({ children }: { children?: ReactNode }) => {
  return (
    <OverlayContainer>
      <div className="loading-mask fixed">
        <FocusScope contain restoreFocus autoFocus>
          <Loading>{children}</Loading>
          <button title="Loading"></button>
        </FocusScope>
      </div>
    </OverlayContainer>
  );
};

export default Loading;
